import { useEffect } from 'react';

import { usePlaySound } from './usePlaySound';
import { SoundId } from './soundConstants';

/** Plays a sound once when the component mounts (e.g. a toolbar or panel appearing). */
export const useMountSound = (soundId: SoundId) => {
    const playSound = usePlaySound();
    useEffect(() => {
        playSound(soundId);
        // Mount only — intentionally not re-running if the flag flips mid-life
    }, []);
};
